import DocumentTitle from "react-document-title";
import React from "react";
import { AzureSaasAttach } from "./login/azure";

/**
 * Landing page for redirect from Azure marketplace
 * @returns {JSX.Element}
 * @constructor
 */
function AzureMarketplace() {
  return (
    <DocumentTitle title="Upsolver">
      <div className="marketplace">
        <h2>Azure Marketplace Integration</h2>
        <AzureSaasAttach />
      </div>
    </DocumentTitle>
  );
}

export default AzureMarketplace;
